import type { TOC } from '@ember/component/template-only'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'

interface Signature {
  Element: HTMLSpanElement
  Args: {
    month: string
    day: string
  }
}

export const CalendarIcon: TOC<Signature> = <template>
  <span data-test-calendar-icon class="relative text-xs font-semibold print:text-sm" ...attributes>
    <PhosphorIcon @icon="phosphor-calendar-blank-fill" class="h-14 w-14 print:hidden" />

    <span
      data-test-calendar-icon-month
      class="absolute -top-0.5 left-0 w-full text-center text-white print:static print:text-left print:text-black"
    >{{@month}}</span>
    <span
      data-test-calendar-icon-day
      class="absolute top-3 left-0 w-full text-center leading-none text-white print:static print:text-left print:text-black"
    >{{@day}}</span>

  </span>
</template>

export default CalendarIcon
